import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { CoreState } from '../core.state';

const featureSelector = createFeatureSelector('core');

export const selectMessageEntitiesState = createSelector(featureSelector, (state: CoreState) => state.messages);

export const selectMessageEntities = createSelector(selectMessageEntitiesState, state => state.messageEntities);
